@if (value) {
  <a
    data-dd-action-name="cell-renderers.record-link"
    [attr.href]="value"
    target="_blank"
    rel="noopener noreferrer"
    >Record <i-lucide name="external-link"></i-lucide
  ></a>
}
